import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { Typography } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAccount } from '@/store/account/types';
import {
    OnboardingWelcomeSkeleton,
    OnboaringWelcomeHeader,
    OnboardingWelcomeWrapper,
    OnboaringWelcomeSubheader,
} from './styles';

export const OnboardingWelcome = () => {
    const { t } = useTranslation();
    const { accountLoading, Profile, warnings } = useSelector(getAccount);

    if (accountLoading || isEmpty(Profile)) {
        return (
            <OnboardingWelcomeSkeleton>
                <Skeleton width={250} height={44} />
                <Skeleton width={350} height={22} />
            </OnboardingWelcomeSkeleton>
        );
    }

    const profileName = Profile.FirstName ?? '';

    return (
        <OnboardingWelcomeWrapper $hasWarnings={!!warnings?.length}>
            <OnboaringWelcomeHeader>
                <Typography variant="h1">{`${t('hello')} ${profileName}`}</Typography>
            </OnboaringWelcomeHeader>
            <OnboaringWelcomeSubheader>
                <Typography variant="h3">{t('dashboardgreeting')}</Typography>
            </OnboaringWelcomeSubheader>
        </OnboardingWelcomeWrapper>
    );
};
